import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { routerReducer } from 'react-router-redux';

import {
  STATE_KEY as RECIPE_KEY,
  reducer as recipeReducer
} from 'src/state/recipe';
import { connectRouter } from 'connected-react-router';

export default (history: any) => combineReducers({
  router: connectRouter(history),
  [RECIPE_KEY]: recipeReducer
});

